export type WizardStep = 'stores' | 'products' | 'inventory';

export const SETUP_STEPS: { id: WizardStep; label: string }[] = [
  { id: 'stores', label: '1. Stores' },
  { id: 'products', label: '2. Products' },
  { id: 'inventory', label: '3. Inventory' },
];
